<template>
  <v-container>
    <h3 class="card-title mb-5">Transactions</h3>
    <v-row v-if="activities.data.length > 0">
      <v-col v-for="(activity, i) in activities.data" cols="12" :key="i">
        <v-card flat class="card dt-border">
          <v-row align="center">
            <v-col cols="12" md="7">
              <span>{{activity.slug}}</span>
              <p>REF : {{activity.reference}} </p>
              <p class="dt-orange__text">{{ formatDate(activity.created) }} / {{ formatTime(activity.created)}}</p>
            </v-col>
            <v-col>
              <p class="mb-0 green--text" v-if="activity.transactiontype == 'credit' "> {{ formatMoney(activity.amount) }}</p>
              <p class="mb-0 red--text" v-if="activity.transactiontype == 'debit' "> - {{ formatMoney(activity.amount) }}</p>
              <v-chip
                pill
                outlined
                small
                label
                v-if="activity.status == 'failed' "
                color="red"
              >
                {{ activity.status }}
              </v-chip>
              <v-chip
                pill
                small
                outlined  
                v-if="activity.status == 'successful' "
                label
                color="green"
              >
                {{ activity.status }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-col v-else>
      <dtunes-empty>
        <template v-slot:title>
          No Transaction
        </template>
    </dtunes-empty>
    </v-col>
    
    <v-row>
      <v-col>
        <v-pagination v-model="page" :length="count" @input="getActivities" rounded="circle"></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// ============ IMPORT COMPONENT  ==============
import DtunesEmpty from "@/components/dtunes-empty.vue"

// =========== IMPORT SERVICES =========
import { parseTimestamp } from '@/utils/dates';
import {formatMoney} from '@/utils/moneyFormatter';
import { UsersService } from '@/services';

export default {

  props:{
    activities : Object 
  },
  data: () => ({
    page: 1,
    count: 0,
    limit: 5,
    activities: [],
  }),
  components:{
    DtunesEmpty
  },
  mounted(){
    this.getActivities()
  },
  methods:{
    async getActivities(){
      try {
        const data = await UsersService.viewUserTransaction({
          id : this.$route.params.id,
          page: this.page,
          limit: this.limit
        });
        this.activities = data;
        this.count = Math.ceil(data.total / this.limit);
      } catch (error) {
        this.loading = false;
      }
    },
    formatDate(date){
      let d = new Date(date)
      let reModelDate = d.toLocaleString(["en-Us"], {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
      return reModelDate;
    },
    formatTime(time){
      return parseTimestamp(new Date(time), 'HH:mm');
    },
    formatMoney(amount){
      return formatMoney(amount)
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
p {
  margin-bottom: unset;
}       
.card-title {
  font-weight: 600 !important;
  font-size: 20px;
  color:$Dtunes-text;
  letter-spacing: 1px;
}
.card{
  background: $Dtunes-offwhite;
  padding: 10px 15px;
  // padding: 2px 5px;
  
}
</style>